import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { withAppState } from "../../state";
import { withRouter } from "react-router-dom";
import getMenuItems, { customSettings } from "./menuItems";
import { MainMenu, ItemMenuMain, Carousel } from "../../services/visualLibraryService";
import menuSettings from "./settings";
import { i18n } from "../../services/i18nService";
import { getLogger } from "../../utils/logger";
import { trackEvent } from "../../services/analyticsService";
import { resolution } from "../../config/ui/resolutionConfig";
import { getSdk } from "../../services/sdkService";
import {
  LayoutLeftArrow,
  LayoutRightArrow,
  FillBtnRightArrow,
  FillBtnLeftArrow,
  LeftArrow,
  RightArrow,
  ShadowLayoutStyledRight,
  ShadowLayoutStyledLeft
} from "./styled";
import { starz1 as Theme } from "starz-visual-themes";
import replaceText from "../../utils/replaceText";

let carousel;
let selectedIndex = 0;
let menuFocused = false;
let isMagicRemoteActive = false;
function goToSlideWithSetTimeout(index) {
  setTimeout(() => {
    carousel.goTo(index);
  }, 300);
}

class MainMenuContainer extends Component {
  constructor(props) {
    super(props);
    this.items = [];
    this.navigate = this.navigate.bind(this);
    this.handleNavigation = this.handleNavigation.bind(this);
    this.handleOppositeSlidesNavigation = this.handleOppositeSlidesNavigation.bind(this);
    this.isReadyToRender = this.isReadyToRender.bind(this);
    this.state = {
      isLogged: props.applicationState.userLogged,
      menuIndex: props.applicationState.focusedMainMenuItemIndex
    };
    this.logger = getLogger();
    this.mouseScroll = true;
  }

  navigate() {
    const item = getMenuItems()[selectedIndex];
    const itemName = item.path.split("/")[1];
    const action = item.isRoot ? this.props.history.replace : this.props.history.push;
    trackEvent("navigation", itemName, itemName);
    if (item.callback) {
      const returnValue = item.callback.call(this);
      if (returnValue) {
        return;
      }
    }
    if (item.path !== "/exit") {
      action(item.path, { preserveFocus: item.isRoot });
    }
  }

  left() {
    carousel.left();
  }

  right() {
    carousel.right();
  }

  shouldComponentUpdate(nextProps, nextState) {
    isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();
    return (
      menuFocused === false ||
      this.props.focused !== nextProps.focused ||
      // FIXME: As we know this is nasty, the state should be a flat object, not referencing other objects.
      // 💩👇
      this.state.isLogged !== nextProps.applicationState.userLogged ||
      this.state.isLogged !== nextState.isLogged ||
      this.state.menuIndex !== nextProps.applicationState.focusedMainMenuItemIndex ||
      this.state.menuIndex !== nextState.menuIndex ||
      this.parentalLevel !== nextProps.applicationState.parentalLevel
    );
  }

  componentDidMount() {
    // FIXME: As we know this is nasty, the state should be a flat object, not referencing other objects.
    // 💩👇
    this.setState({
      isLogged: this.props.applicationState.userLogged,
      menuIndex: this.props.applicationState.focusedMainMenuItemIndex
    });
    this.parentalLevel = this.props.applicationState.parentalLevel;
    this.props.onRef && this.props.onRef(this);
  }

  componentDidUpdate() {
    const {
      handleFocus,
      focused,
      applicationState: { focusedMainMenuItemIndex, userLogged, parentalLevel }
    } = this.props;
    handleFocus(focused);
    // NOTE: This will track the event even if menu is focused at page first rendering.
    focused === true &&
      trackEvent("navigation", "show menu", getMenuItems()[focusedMainMenuItemIndex]?.path?.split("/")[1]);
    // FIXME: As we know this is nasty, the state should be a flat object, not referencing other objects.
    // 💩👇
    if (
      this.state.isLogged !== userLogged ||
      this.state.menuIndex !== focusedMainMenuItemIndex ||
      this.parentalLevel !== parentalLevel
    ) {
      this.parentalLevel = parentalLevel;
      this.setState({
        isLogged: userLogged,
        menuIndex: focusedMainMenuItemIndex
      });
    }
    menuFocused = true;
    isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();
  }

  componentWillUnmount() {
    menuFocused = false;
  }

  handleOppositeSlidesNavigation(oldIndex, newIndex) {
    if (newIndex === carousel.currentSlide) {
      if (carousel.isFirstSlide) {
        goToSlideWithSetTimeout(carousel.slideCount - 1);
      } else if (carousel.isLastSlide) {
        goToSlideWithSetTimeout(0);
      }
    }
  }

  handleNavigation(index) {
    selectedIndex = index;
    this.props.applicationState.focusedMainMenuItemIndex = index;
  }

  checkInitialSlideIndex() {
    const {
      applicationState: { focusedMainMenuItemIndex },
      location
    } = this.props;
      let index = focusedMainMenuItemIndex > getMenuItems().length - 1 ? 0 : focusedMainMenuItemIndex;
      if(!location.pathname.includes('brands')){
        index = (getMenuItems() || []).findIndex(values => values.path === location.pathname);
      } else {
        index = (getMenuItems() || []).findIndex(values => values.path === '/brands');
      }
      selectedIndex = index;
      this.props.applicationState.focusedMainMenuItemIndex = index;
  }

  isReadyToRender() {
    const { isLogged, menuIndex } = this.state;
    return (
      isLogged === this.props.applicationState.userLogged &&
      menuIndex === this.props.applicationState.focusedMainMenuItemIndex
    );
  }

  render() {
    const { className } = this.props;
    const { isLogged } = this.state;
    const config = { ...menuSettings };
    const LeftRightArrowStyles = {
      display: isMagicRemoteActive && className.indexOf("focused") !== -1 ? "block" : "none"
    };

    const menu = getMenuItems();
    this.checkInitialSlideIndex();
    return (
      <MainMenu className={className} isLogged={isLogged}>
        <LayoutLeftArrow style={LeftRightArrowStyles}>
          <LeftArrow
            xmlns="http://www.w3.org/2000/svg"
            onClick={i18n.getDirection() !== "rtl" ? this.left : this.right}
          >
            <FillBtnLeftArrow />
          </LeftArrow>
          <ShadowLayoutStyledLeft />
        </LayoutLeftArrow>
        <LayoutRightArrow style={LeftRightArrowStyles}>
          <RightArrow
            xmlns="http://www.w3.org/2000/svg"
            onClick={i18n.getDirection() !== "rtl" ? this.right : this.left}
          >
            <FillBtnRightArrow />
          </RightArrow>
          <ShadowLayoutStyledRight />
        </LayoutRightArrow>

        {// FIXME: Carousel items are forced to match the used state as logged in or not.
        this.isReadyToRender() && (
          <Carousel
            settings={config}
            ref={ref => (carousel = ref)}
            direction={i18n.getDirection()}
            onChange={this.handleNavigation}
            beforeChange={this.handleOppositeSlidesNavigation}
            initialSlide={this.props.applicationState.focusedMainMenuItemIndex || 0}
            items={menu}
            isMainMenu={true}
            slideMargin={Theme.components.carousel.slideMargin.mainMenu}
            slideMarginStart={resolution.carousel.slideMarginStart.mainMenu}
          >
            {menu.map((item, index) => {
              const iconSettings = (item.icon && customSettings[item.icon]) || {};
              return (
                <ItemMenuMain
                  key={`item_${item.name}_${index}_${new Date().getTime()}`}
                  to={item.path == "/exit" ? {} : item.path}
                  label={item.name && i18n.get(`global.sections.${item.name}`)}
                  background={this.props.location.pathname !== "/kids" ? item.background : ""}
                  use={NavLink}
                  onClickHandler={() => {
                    if (item.callback) {
                      const returnValue = item.callback.call(this);
                      if (returnValue) {
                        return;
                      }
                    } else {
                    }
                  }}
                  icon={item.icon}
                  isMainMenu={true}
                  svgUrl={
                    !item.svgUrl
                      ? null
                      : this.props.location.pathname !== "/kids"
                      ? replaceText(item.svgUrl, { kids: "" })
                      : replaceText(item.svgUrl, { kids: "-kids" })
                  }
                  iconWidth={iconSettings.iconWidth}
                  iconHeight={iconSettings.iconHeight}
                  direction={i18n.getDirection()}
                  iconDescription={item.iconDescription}
                  onRef={ref => this.items.push(ref)}
                  lockIconShouldAppear={item.lockIconShouldAppear}
                />
              );
            })}
          </Carousel>
        )}
      </MainMenu>
    );
  }
}

export default withRouter(withAppState(MainMenuContainer));
